import * as React from 'react';

import { cn } from '@/lib/utils';

/**
 * shadcn `Skeleton` primitive — a muted pulsing rectangle that stands
 * in for content while it loads. Per [apps/web/CLAUDE.md §7](../../../CLAUDE.md):
 * skeletons for content load, spinners for actions in flight. Compose
 * into shape-matching placeholders alongside the eventual content so
 * the swap is jank-free (e.g. `<TableSkeleton>` for a table mount).
 */
function Skeleton({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="skeleton"
      className={cn('bg-accent animate-pulse rounded-md', className)}
      {...props}
    />
  );
}

export { Skeleton };
